import { geoBounds } from "d3-geo"
import { type Polygon } from "geojson"

/**
 * Mutate input polygon so that values to the left of the antimeridian are always negative
 * @param polygon
 */
export function wrapPolygonLeft(polygon: Polygon): void {
    polygon.coordinates.forEach((ring) => {
        ring.forEach((coord) => {
            if (coord[0] > 0) coord[0] -= 360
        })
    })
}

/**
 * Generate a rectangle with a centered polygon-shaped hole
 *
 * @param polygon Polygon to turn into a cutout
 * @param border Width of the border around the cutout
 * @returns Rectangle with a hole the shape of the input polygon's outer ring
 */
export function cutout(polygon: Polygon, border: number): Polygon {
    wrapPolygonLeft(polygon)
    let [[w, s], [e, n]] = geoBounds(polygon) as [
        [number, number],
        [number, number]
    ]

    if (e > 0) e -= 360
    if (w > 0) w -= 360
    console.log(n, e, s, w, border)
    // Offset bounds by threshold
    n += border
    e += border
    s -= border
    w -= border

    console.log(n, e, s, w, border)
    const boxCoordinates = [
        [w, n],
        [e, n],
        [e, s],
        [w, s],
        [w, n],
    ]

    const polyWithHole: Polygon = {
        type: "Polygon",
        coordinates: [boxCoordinates, ...polygon.coordinates],
    }

    console.log(polyWithHole)

    return polyWithHole
}
